'use client'

import type { ReactNode } from 'react'

import { useVaultRoute } from './VaultRouteContext'

export interface VaultRouteLoadingProps {
  v1: ReactNode
  v2: ReactNode
}

/** Shows the route loader for the resolved vault's version, V2 when it is unknown. */
const VaultRouteLoading = ({ v1, v2 }: VaultRouteLoadingProps) => {
  return useVaultRoute()?.isVaultV2 === false ? v1 : v2
}

export default VaultRouteLoading
